import { useContext } from "react";
import common from '../../common.module.css';
import { ModalCopyMaterial } from "../..";
import Select from "@UI/New/Select";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";

export const Totic = () => {
    const { 
          materials,
          loadingMaterials,
          state,
          setFieldInState,
        } = useContext(ModalCopyMaterial);

    const toticsOptions = materials?.data?.filter((el)=>el.type === 'topic')?.map((material)=>({label: material.name, value: Number(material.id)}));

    const fieldsMaterials = {
        loading: loadingMaterials,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: value => {
            setFieldInState({field: 'topic_id', value})
        },
        options: toticsOptions,
        value: state?.topic_id,
        placeholder: 'Выберите тему',
        notFoundContent: "Темы не найдены",
        disabled: loadingMaterials
    };

    return (
        <>
            <div className={common.wrapper}>
                <span>Выберите тему</span>
                <Select 
                    wrapperClassName={common.wrapperSelect} 
                    className={common.select} 
                    fields={fieldsMaterials} 
                />
            </div>
        </>
    )
}
